import { render, staticRenderFns } from "./VisualizarGrupoDialog.vue?vue&type=template&id=d825ef64"
import script from "./VisualizarGrupoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarGrupoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports